import { RequestTypes } from '../hooks/useRequest'

export const GREEN_TOOLS_API_PREFIX = '/api/green-tools/v1/'
export const GREEN_TOOLS_CREDENTIALS = 'contracts/set-consumers'
export const GREEN_TOOLS_PAYMENT = 'contracts/payment-buyer-fee'
export const GREEN_TOOLS_FILE = 'contracts/get-consumers-from-file'

export const sendRealization = {
    link: `${GREEN_TOOLS_API_PREFIX}${GREEN_TOOLS_CREDENTIALS}`,
    method: RequestTypes.post,
}

export const payRealization = {
    link: `${GREEN_TOOLS_API_PREFIX}${GREEN_TOOLS_PAYMENT}`,
    method: RequestTypes.post,
}

export const getFromFile = {
    link: `${GREEN_TOOLS_API_PREFIX}${GREEN_TOOLS_FILE}`,
    method: RequestTypes.post,
}
